var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('div',{staticClass:"text-h1"},[_vm._v(" Page not found ")]),_c('div',{staticClass:"mt-12"},[_vm._v(" Sorry, this page doesn't exist. ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }